import qs from 'qs';

import type { AppRouteBeforeServerRenderContext } from 'src/shared/routes';

import { getTopicSlug } from 'src/app/shared/api/topics';

/**
 * `handleTopicsRedirect` redirects to to `/t/:slug` if the topic page by
 * slug is not returned from `topicPageBySlug`, meaning it should return
 * the tag page.
 */
export const handleTagRedirect = async ({
	utilities,
	redirect,
	params: { slug },
	query,
}: AppRouteBeforeServerRenderContext): Promise<void> => {
	const { slug: topicSlug } = await getTopicSlug(utilities, slug);
	const queryString = qs.stringify(query, { addQueryPrefix: true });

	if (!topicSlug) {
		const targetPath = `/t/${slug}${queryString}`;
		redirect(targetPath, true);
	}
};
